<template>

    <div class="modal fade" id="saveSearch" tabindex="-1" role="dialog" aria-labelledby="saveSearchModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="section-title no-margin" id="saveSearchModalTitle">Guardar Pesquisa</h3>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="modal-body top-padding">

                    <form class="ink-form" >

                        <div class="control-group required column-group half-gutters no-margin">
                            <label for="serchName" class="all-15 align-right inline unsigned">Nome</label>
                            <div class="control all-85">
                                <input type="text" name="serchName" id="serchName" v-model="name" value="AutoSAPO 20/02/22 15:00h">
                            </div>
                            <p class="error">Erro</p>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="ink-button" data-dismiss="modal">Fechar</button>
                    <button type="button" class="ink-button main-action min-width" v-on:click="onClickSaveSearch">Guardar</button>
                </div>
            </div>
            
            
        </div>
    </div>

</template>

<script>
import SearchService from '../scripts/services/pesquisa.js'
import NewVehiclesSearchService from '../scripts/services/pesquisa-new-vehicle.js'
import Notifications from "../scripts/notifications"

export default {

    data(){
        return {
            name: "AutoSAPO" + (this.isUsedVehicles ? " - Usados - " : " - Novos - ") + moment().format("DD/MM/YYYY HH:mm") + "h"
        }
    },
    props:{
        isUsedVehicles: {
            type: Boolean,
            default: true
        }
    },
    mounted (){

    },
    methods: {
        async onClickSaveSearch(){

            // updates the search session var before saving
            this.$emit("update-search");
            this.$emit("updateSearch");

            // Get queryString

            var result;
            if (this.isUsedVehicles){
                result = await SearchService.SaveSearch(this.name, window.location.search);
            }else{
                result = await NewVehiclesSearchService.SaveSearch(this.name, window.location.search);
            }
            
            if (result && !result.Sucesso){
                if (result.Errors != null && result.Errors.length > 0){
                    var validationError = result.Errors.filter(err => err.Nature == 'v')[0];
                    if (validationError != null){
                        Notifications.Warning("Pesquisas Guardadas", validationError.Message);                        
                    }
                }
            }

            this.$emit("OnSearchSaved");
            this.$emit("on-search-saved");
        }
    }
};
</script>